"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserValidationGroups = void 0;
var UserValidationGroups;
(function (UserValidationGroups) {
    UserValidationGroups["PROFILE"] = "profile";
    UserValidationGroups["BILLING"] = "billing";
    UserValidationGroups["DRIVER"] = "driver";
    UserValidationGroups["DRIVER_COMPANY"] = "driverCompany";
    UserValidationGroups["TRAVEL_AGENT"] = "travelAgent";
    UserValidationGroups["HYPERWALLET_INFORMATION"] = "hyperwalletInformation";
    UserValidationGroups["STRIPE_INFORMATION"] = "stripeInformation";
})(UserValidationGroups || (exports.UserValidationGroups = UserValidationGroups = {}));
//# sourceMappingURL=UserValidationGroups.js.map